module.exports = __webpack_public_path__ + "img/cart-bg.f151f6e6.png";